import { z } from 'zod';

/////////////////////////////////////////
// DEPARTMENTS SCHEMA
/////////////////////////////////////////

export const DepartmentsSchema = z.object({
  departmentId: z.number().int(),
  cityId: z.number().int(),
  name: z.string(),
  assignToId: z.number().int(),
  managerId: z.number().int(),
  expectCloseDays: z.string(),
  notifyId: z.number().int(),
  defaultTopicFilterId: z.number().int(),
  parentDepartmentId: z.number().int(),
  rowTimestamp: z.coerce.date(),
})

export type Departments = z.infer<typeof DepartmentsSchema>

export default DepartmentsSchema;
